import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Row, Alert } from "react-bootstrap";
import { TreeSelect } from "antd";

import * as Template from "../../templates";
import * as actions from "../../actions";
import { useParams } from "react-router-dom";
import EditorField from "../../templates/modules/forms/Editor";

export default (props) => {
  const moduleName = `product_categories`;
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();
  const [name, setName] = useState(``);
  const [ordering, setOrdering] = useState(``);
  const [categoryId, setCategoryId] = useState(null);
  const [categories, setCategories] = useState(``);
  const [logo, setLogo] = useState(``);
  const [verticalBanner, setVerticalBanner] = useState(``);
  const [horizontalBanner, setHorizontalBanner] = useState(``);
  const [homeView, setHomeView] = useState(``);
  const [topView, setTopView] = useState(``);
  const [slug, setSlug] = useState(``);
  const [description, setDescription] = useState(``);
  const [id, setId] = useState();
  const [submitted, setSubmitted] = useState(false);
  const [state, setState] = useState(``);
  const [metaKeywords, setMetaKeywords] = useState(``);
  const [metaDescription, setMetaDescription] = useState(``);
  const [metaTitle, setMetaTitle] = useState(``);
  const [about, setAbout] = useState(``);

  const params = useParams()

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])


  const onChange = (value) => setCategoryId(value);
  const handleChangeHome = (value) => setHomeView(value);
  const handleChangeTopView = (value) => setTopView(value);
  const handleChangeState = (value) => setState(value);
  const handleAboutChange = (value) => setAbout(value);

  const handleClick = () => {
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
    setSubmitted(true)
  };


  useEffect(() => {
    if (submitted) {
      if (
        (appReducer.product_categories_store != undefined && appReducer.product_categories_store.error == false) ||
        (appReducer.product_categories_update != undefined && appReducer.product_categories_update.error == false)
      ) {

      }
    }
    return () => setSubmitted(false)
  }, [
    appReducer.product_categories_store,
    appReducer.product_categories_update
  ])


  useEffect(() => {
    if (appReducer.product_categories_tree_select_list != undefined) {
      setCategories(appReducer.product_categories_tree_select_list.data);
    }
  }, [appReducer.product_categories_tree_select_list]);

  useEffect(() => {
    if (appReducer.product_categories_edit != undefined && id != undefined) {
      let row = appReducer.product_categories_edit.data;
      if (row) {
        setName(row.name);
        setSlug(row.slug);
        setLogo(row.logo_full);
        setOrdering(row.ordering)
        setMetaTitle(row.meta_title)
        setMetaDescription(row.meta_description)
        setMetaKeywords(row.meta_keywords)
        setState({
          value: row.state,
          label: row.state == `active` ? `فعال` : `غیرفعال`,
        });
        setDescription(row.description)
        setVerticalBanner(row.vertical_banner_full);
        setHorizontalBanner(row.horizontal_banner_full)
        setHomeView({
          value: row.home_view,
          label: row.home_view == `active` ? `فعال` : `غیرفعال`,
        });
        setTopView({
          value: row.top_view,
          label: row.top_view == `active` ? `فعال` : `غیرفعال`,
        });
        setAbout(row.about);
        if (row.parent_id > 0) {
          setCategoryId(row.parent_id);
        }
      }

    }
  }, [appReducer.product_categories_edit]);

  useEffect(() => {
    dispatch(actions.list(`product_categories/tree_select`));
  }, []);

  useEffect(() => {
    setCategoryId(null)
    if (id != undefined) {
      dispatch(actions.edit(id, moduleName));
    }
  }, [id]);

  return (
    <Row>
      <Template.Card col="col-md-6 col-xs-12 col-sm-12" title={props.page}>
        <Template.Form hasGrid={true}>
          <Template.Input required value={name} label="نام" name="name" type="text" />
          <Template.Input required value={slug} label="لینک" name="slug" type="text" />
          <Template.Input required value={ordering} label="ترتیب نمایش" name="ordering" type="text" />
          <Template.Input value={description} label="معرفی دسته‌بندی" name="description" type="text" />
          <div>
            <EditorField
              label="توضیحات"
              onEditorChange={handleAboutChange}
              value={about}
            />
            <input name="about" type="hidden" defaultValue={about} />
          </div>
          <Template.FileInput
            deleteUrl="product_categories/destroy_image"
            className="logo"
            value={logo && [logo]}
            name="logo"
            rowId={id}
            label="لوگو"
          />
          <Template.FileInput
            deleteUrl="product_categories/destroy_vertical_banner"
            className="vertical_banner"
            value={verticalBanner && [verticalBanner]}
            name="vertical_banner"
            rowId={id}
            label="بنر افقی"
          />
          <Template.FileInput
            deleteUrl="product_categories/destroy_horizontal_banner"
            className="horizontal_banner"
            rowId={id}
            value={horizontalBanner && [horizontalBanner]}
            name="horizontal_banner"
            label="بنر عمودی"
          />
          <Template.SingleSelect
            withLabel
            required
            placeholder="نمایش در صفحه اصلی"
            onChange={handleChangeHome}
            name="home_view"
            value={homeView}
            options={[
              {
                value: "active",
                label: "فعال",
              },
              {
                value: "deactive",
                label: "غیرفعال",
              },
            ]}
          />
          <Template.SingleSelect
            withLabel
            required
            placeholder="وضعیت"
            onChange={handleChangeState}
            name="state"
            value={state}
            options={[
              {
                value: "active",
                label: "فعال",
              },
              {
                value: "deactive",
                label: "غیرفعال",
              },
            ]}
          />
          <Template.SingleSelect
            withLabel
            required
            placeholder="پیشنهاد عبیدیکا"
            onChange={handleChangeTopView}
            name="top_view"
            value={topView}
            options={[
              {
                value: "active",
                label: "فعال",
              },
              {
                value: "deactive",
                label: "غیرفعال",
              },
            ]}
          />

          <div className={`form-group mt-2`}>
            <label>انتخاب سرگروه </label>
            <TreeSelect
              treeData={categories}
              showSearch
              style={{ width: "100%" }}
              value={categoryId}
              dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
              placeholder="انتخاب گروه"
              allowClear
              treeDefaultExpandAll
              onChange={onChange}
            />
            <input type="hidden" defaultValue={categoryId} name="parent_id" />
          </div>

          <Template.Seo
            keywords={metaKeywords}
            description={metaDescription}
            title={metaTitle}
          />

          <Template.Button
            label="ذخیره"
            onClick={handleClick}
          />
        </Template.Form>
      </Template.Card>
    </Row>
  );
};
